import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import theme from './theme'
import Home from './views/Home'
import Header from './views/Header'
import Footer from './views/Footer'
import Membership from './views/Section/Membership'
import MembershipInfoPage from './views/MembershipInfoPage'
import WorkshopDetail from './views/WorkshopDetail'
import { LanguageProvider } from './context/LanguageContext'
import SkillsetCourse from './views/Course/SkillsetCourse'
import BusinessManagement from './views/Course/BusinessManagement'


function App() {
  return (
    <ThemeProvider theme={theme}>
      <LanguageProvider>
        <CssBaseline />
        <Router>
          <div className="app">
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/package" element={<Membership />} />
              <Route path="/package/:packageName" element={<MembershipInfoPage />} />
              <Route path="/skillset-course" element={<SkillsetCourse />} />
              <Route path="/business-management" element={<BusinessManagement />} />
              <Route path="/workshop/detail" element={<WorkshopDetail />} />
            </Routes>
            <Footer />
          </div>
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  )
}

export default App